import actionCreatorFactory from 'typescript-fsa';
import { FeaturedCluster } from './featured-cluster.reducer';
const actionCreator = actionCreatorFactory('FeaturedClusters');

export const loadFeaturedClusters = actionCreator('LOAD_FEATURED_CLUSTERS');
export const updateFeaturedClusters = actionCreator<{
  [key: number]: FeaturedCluster;
}>('UPDATE_FEATURED_CLUSTERS');

export const addFeaturedCluster = actionCreator<FeaturedCluster>(
  'FEATURED_CLUSTERS_ADD'
);

export const removeFeaturedCluster = actionCreator<FeaturedCluster>(
  'FEATURED_CLUSTERS_REMOVE'
);

export const removeUnsavedFeaturedClusters = actionCreator(
  'FEATURED_CLUSTERS_REMOVE_UNSAVED'
);



// WEBPACK FOOTER //
// ./src/store/Entities/FeaturedCluster/featured-cluster.actions.ts